import { render, staticRenderFns } from "./AdmissionFees.vue?vue&type=template&id=081d393a"
import script from "./AdmissionFees.vue?vue&type=script&lang=js"
export * from "./AdmissionFees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports